import * as React from "react";
import { SVGProps } from "react";

const Vite = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 963" {...props}>
    <path d="m0 234.7 285.3 727.6 31.6-798.8zm389.3-84.9-94 813.6L1024 0z" />
  </svg>
);

export default Vite;
